module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp1_6005.9bf539f6.png";